import http from '../http';

export const getWasteCompanies = () => {
  return http.get(`/admin/companies/waste`);
};

export const getTransportCompanies = () => {
  return http.get(`/admin/companies/transport`);
};

export const getAuthTokenForCompany = (companyId: number, isTransport: boolean) => {
  return http.post(`/admin/companies/${companyId}/auth-token?isTransport=${isTransport}`);
};
